function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useEffect } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { AddButton, SaveButton } from '@rd-web-markets/shared/dist/util/buttons';
import { DeleteButton } from '@rd-web-markets/shared/dist/util/buttons/DeleteButton';
import { IntegerFormFieldRow, TextFormFieldRow } from '@rd-web-markets/shared/dist/util/form';
import partnershipPartyService from '../../../services/elster/partnership_party.service';
const TEXT_FIELDS = ['num_of_parties_involved', 'name', 'forename', 'street', 'house_number', 'postal_code', 'city', 'tin', 'identification', 'type_of_participant'];
const INTEGER_FIELDS = ['numerator_at_the_end_of_the_financial_year', 'denominator_at_the_end_of_the_financial_year'];
const PartnershipParties = _ref => {
  let {
    partnership,
    setPartnership,
    setLoading
  } = _ref;
  const {
    t
  } = useTranslation();
  const parties = (partnership === null || partnership === void 0 ? void 0 : partnership.partnership_parties) || [];
  const {
    fetchParties,
    createParty,
    updateParty,
    deleteParty
  } = partnershipPartyService.useCrud(partnership === null || partnership === void 0 ? void 0 : partnership.id, setLoading, setPartnership);
  useEffect(() => {
    if ((partnership === null || partnership === void 0 ? void 0 : partnership.id) != null) {
      fetchParties();
    }
  }, [partnership === null || partnership === void 0 ? void 0 : partnership.id, fetchParties]);
  const handleChange = useCallback((party, field, value) => {
    setPartnership(prev => {
      if (!prev) return prev;
      const list = prev.partnership_parties || [];
      return _objectSpread(_objectSpread({}, prev), {}, {
        partnership_parties: list.map(item => item.id === party.id ? _objectSpread(_objectSpread({}, item), {}, {
          [field]: value,
          saved: false
        }) : item)
      });
    });
  }, [setPartnership]);
  const saveParty = useCallback(async party => {
    if (party.saved !== false) return;
    await updateParty({
      id: party.id,
      partnership_party: {
        num_of_parties_involved: party.num_of_parties_involved,
        name: party.name,
        forename: party.forename,
        street: party.street,
        house_number: party.house_number,
        postal_code: party.postal_code,
        city: party.city,
        tin: party.tin,
        identification: party.identification,
        type_of_participant: party.type_of_participant,
        numerator_at_the_end_of_the_financial_year: party.numerator_at_the_end_of_the_financial_year,
        denominator_at_the_end_of_the_financial_year: party.denominator_at_the_end_of_the_financial_year
      }
    });
  }, [updateParty]);
  const handleAddParty = useCallback(async () => {
    if ((partnership === null || partnership === void 0 ? void 0 : partnership.id) == null) return;
    await createParty({
      name: ''
    });
  }, [createParty, partnership === null || partnership === void 0 ? void 0 : partnership.id]);
  const renderIntegerField = (party, fieldName) => /*#__PURE__*/React.createElement(React.Fragment, null, fieldName === 'numerator_at_the_end_of_the_financial_year' && /*#__PURE__*/React.createElement("p", {
    className: "fw-bold mt-5"
  }, t('information_on_breakdown_11')), /*#__PURE__*/React.createElement(Form.Group, {
    key: "".concat(party.id, "-").concat(fieldName),
    as: Row,
    className: "mb-2"
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: true,
    md: 6
  }, t(fieldName)), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(IntegerFormFieldRow, {
    fieldName: fieldName,
    value: party[fieldName] != null && party[fieldName] !== '' ? String(party[fieldName]) : '',
    onChange: e => handleChange(party, fieldName, e.target.value),
    dataTestId: "partnership_party_".concat(party.id, "_").concat(fieldName),
    style: {
      width: ''
    }
  }))));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, {
    className: "align-items-center mb-3",
    style: {
      marginTop: '60px'
    }
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h3", {
    className: "mb-0"
  }, t('details_of_the_parties_involved_in_the_assessment')))), parties.map(party => /*#__PURE__*/React.createElement("div", {
    key: "partnership-party-".concat(party.id),
    className: "mb-4 pb-3 border-bottom",
    style: {
      marginTop: '30px'
    }
  }, /*#__PURE__*/React.createElement(Row, {
    className: "align-items-center mb-2"
  }, /*#__PURE__*/React.createElement(Col, {
    xs: "auto",
    className: "pe-4"
  }, /*#__PURE__*/React.createElement(DeleteButton, {
    onClick: () => deleteParty(party)
  }))), TEXT_FIELDS.map(fieldName => {
    var _party$fieldName;
    return /*#__PURE__*/React.createElement(TextFormFieldRow, {
      key: "".concat(party.id, "-").concat(fieldName),
      fieldName: fieldName,
      label: fieldName,
      value: (_party$fieldName = party[fieldName]) !== null && _party$fieldName !== void 0 ? _party$fieldName : '',
      onChange: e => handleChange(party, fieldName, e.target.value),
      labelColSpan: 6,
      dataTestId: "partnership_party_".concat(party.id, "_").concat(fieldName)
    });
  }), INTEGER_FIELDS.map(fieldName => renderIntegerField(party, fieldName)), party.saved === false && /*#__PURE__*/React.createElement("div", {
    className: "text-end"
  }, /*#__PURE__*/React.createElement(SaveButton, {
    onClick: () => saveParty(party),
    dataTestid: "save_party_button",
    text: t('click_to_save'),
    className: "ms-auto me-3"
  })))), /*#__PURE__*/React.createElement(AddButton, {
    variant: "primary",
    disabled: (partnership === null || partnership === void 0 ? void 0 : partnership.id) == null,
    onClick: handleAddParty,
    text: t('add_party')
  }));
};
export default PartnershipParties;